import { render, staticRenderFns } from "./candidatosResultados.vue?vue&type=template&id=b5af5a92&"
import script from "./candidatosResultados.vue?vue&type=script&lang=js&"
export * from "./candidatosResultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports